import { pick } from 'lodash/fp';

import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { SortParams } from 'dashboard/lib/interfaces/SortParams';
import { CaseTemplate, CaseTemplateBasicsResponse } from 'dashboard/models/case-template';
import {
  CaseTemplatesFilterParams,
  setCaseTemplateBasicsOptions,
  setCaseTemplates,
} from 'dashboard/redux/actions/case-templates';
import { DashboardThunkAction } from 'dashboard/redux/types';
import { ApiEndpoint, PaginationParams } from 'lib/interfaces/api';

export function loadCaseTemplatesList({
  currentPage,
  pageSize,
  sortParams,
  filters,
  abortSignal,
}: {
  currentPage: number;
  pageSize: number;
  sortParams: SortParams;
  filters: CaseTemplatesFilterParams;
  abortSignal?: AbortSignal;
}): DashboardThunkAction<Promise<void>> {
  return async (dispatch) => {
    const params = createParamsForList(filters, sortParams);
    const paramsFull = {
      ...params,
      page: {
        number: currentPage,
        size: pageSize,
      },
      signal: abortSignal,
    };

    const caseTemplatesResponse = await SessionClientDashboard.listResource<
      CaseTemplate,
      PaginationParams & { 'at-active-case-template-limit': boolean }
    >(ApiEndpoint.CaseTemplate, paramsFull);

    const caseTemplates = caseTemplatesResponse.data;
    /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
    const paginationParams: PaginationParams = pick(
      ['current-page', 'total-pages', 'total-count'],
      caseTemplatesResponse.meta,
    );
    const atActiveCaseTemplateLimit = caseTemplatesResponse.meta?.['at-active-case-template-limit'];

    /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
    dispatch(setCaseTemplates(caseTemplates, paginationParams, atActiveCaseTemplateLimit));
  };
}

export const loadCaseTemplateBasicsOptions = (): DashboardThunkAction<Promise<void>> => {
  return async (dispatch) => {
    const { meta } = await SessionClientDashboard.get<CaseTemplateBasicsResponse>(
      ApiEndpoint.CaseTemplate,
      'basics',
      '',
    );
    dispatch(setCaseTemplateBasicsOptions(meta.basics));
  };
};

function createParamsForList(
  caseTemplateFilters: CaseTemplatesFilterParams,
  caseSortParams: SortParams,
) {
  const { createdAtStart, createdAtEnd, status, caseTemplateIds, omni } = caseTemplateFilters;
  const { sort, shouldSortDescending } = caseSortParams;

  return {
    filter: {
      'created-at-start': createdAtStart?.toString(),
      'created-at-end': createdAtEnd?.toString(),
      'case-template-ids': caseTemplateIds,
      status,
      omni,
    },
    sort: `${shouldSortDescending ? '-' : ''}${sort}`,
  };
}
